import { useServiceFactory } from '@euler/services/factory';
import { useCallback } from 'react';
import { CaseListState, useCaseList } from './useCaseList';

/** Every case related to one, for its 相关案例 page. */
export function useRelatedCases(caseId: string): {
  state: CaseListState;
  reload: () => void;
} {
  const { coachingService } = useServiceFactory();
  const load = useCallback(
    async () => (await coachingService.getRelatedCases(caseId)).cases,
    [coachingService, caseId],
  );
  return useCaseList(load, 'related cases');
}
